import angular from 'angular';

import InventoryHeaderComponent from './inventory-header-component';

export default angular.module('inventory-header', []).component('inventoryHeader', new InventoryHeaderComponent());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-header/inventory-header-module.js